import { render } from "./ToothSelectGroup.vue?vue&type=template&id=76d37726"
import script from "./ToothSelectGroup.vue?vue&type=script&lang=js"
export * from "./ToothSelectGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__